<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="项目名">
              <j-search-select-tag
                v-model="queryParam.entryName"
                placeholder="请选择项目名"
                ref="searchProjectName"
                :dictOptions="entryNameList"
                mode="default"
                @change="entryNamesearchQuery"
              >
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="queryParam.entryName">
            <a-form-item label="模块">
              <j-search-select-tag
                v-model="queryParam.moduleName"
                placeholder="请选择模块"
                ref="searchModuleName"
                :dictOptions="moduleNameList"
                mode="default"
              >
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="loadData" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <v-form-render v-if="formJson" :form-json="formJson" :form-data="formData" :option-data="optionData" ref="vFormRef">
    </v-form-render>
  </a-card>
</template>

<script>
import { deleteAction, postAction, getAction } from '@/api/manage'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import ElementUI from 'element-ui' //引入element-ui库
import Vue from 'vue'
Vue.use(ElementUI) //全局注册element-ui
export default {
  name: 'VformShow',
  components: { JSearchSelectTag },
  data() {
    return {
      formJson: '',
      formData: {},
      optionData: {},
      url: {
        getTheLatestVersion: '/vform/busVformManage/getTheLatestVersion', //获取最新的版本号
        getEntryName: '/vform/busVformManage/getEntryName', //项目接口
        getModuleName: '/vform/busVformManage/getModuleName', //项目下的模块
        getAllTheData: '/vform/busVformManage/getAllTheData',
      },
      queryParam: {},
      entryNameList: [], //项目名称数组
      moduleNameList: [], //模块数组
    }
  },
  created() {
    const that = this
    postAction(that.url.getEntryName, {}).then((res) => {
      console.log(res)
      that.entryNameList = res.result.map((item) => {
        let obj = {
          value: item.entryName,
          title: item.entryName,
          text: item.entryName,
        }
        return obj
      })
      that.$refs.searchProjectName.setCurrentDictOptions(that.entryNameList)
    })
  },
  methods: {
    entryNamesearchQuery(val) {
      console.log(val)
      const that = this
      getAction(that.url.getModuleName, { entryName: val }).then((res) => {
        console.log(res)

        that.moduleNameList = res.result.map((item) => {
          let obj = {
            value: item.moduleName,
            title: item.moduleName,
            text: item.moduleName,
          }
          return obj
        })
        that.$refs.searchModuleName.setCurrentDictOptions(that.moduleNameList)
      })
    },
    loadData() {
      const that = this
      getAction(that.url.getTheLatestVersion, that.queryParam).then((res) => {
        console.log(res)
        // getAllTheData
        let obj = { ...that.queryParam, versionNumber: res.result[0].versionNumber }
        getAction(that.url.getAllTheData, obj).then((res) => {
          console.log(res)
          that.formJson = JSON.parse(res.result[0].content)
        })
      })
    },
    searchReset() {
      this.queryParam = {}
    },
    submitForm() {
      this.$refs.vFormRef
        .getFormData()
        .then((formData) => {
          // Form Validation OK
          alert(JSON.stringify(formData))
        })
        .catch((error) => {
          // Form Validation failed
          this.$message.error(error)
        })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
</style>
